import { withStyles } from '@material-ui/core';

import ContentForm from './component';
import styles from './styles';

export default withStyles(styles)(ContentForm);
